

































































































import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import FormError from '@front-app/components/form/FormError.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import { useHighlightsInput } from '@front-app/modules/group/highlights/hooks/useHighlightsInput';
import {
	HighlightsButtonStyle,
	HighlightsElementPalette,
} from '@front-app/modules/group/highlights/model';
import BasicTextEditor from '@front-app/components/inputs/BasicTextEditor.vue';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import { useTranslate } from '@front-app/hooks/useTranslate';
import { computed, defineComponent, onMounted } from '@vue/composition-api';
import BaseEditor from '../../BaseEditor.vue';
import ActionSelector from '../editorSections/ActionSelector.vue';
import { BUTTON_EDITOR_PROPS } from './buttonEditor';

const DEFAULT_PALETTE_KEY = 'DEFAULT_PALETTE_KEY';

const PALETTE_OPTION_LABELS: Record<string | HighlightsElementPalette, string> = {
	[DEFAULT_PALETTE_KEY]: 'default',
	[HighlightsElementPalette.PRIMARY]: 'color-palette.primary',
	[HighlightsElementPalette.SECONDARY1]: 'color-palette.secondary-1',
	[HighlightsElementPalette.SECONDARY2]: 'color-palette.secondary-2',
	[HighlightsElementPalette.SECONDARY3]: 'color-palette.secondary-3',
};

const PALETTE_OPTIONS = [
	DEFAULT_PALETTE_KEY,
	HighlightsElementPalette.PRIMARY,
	HighlightsElementPalette.SECONDARY1,
	HighlightsElementPalette.SECONDARY2,
	HighlightsElementPalette.SECONDARY3,
];

const STYLE_OPTION_LABELS: Record<HighlightsButtonStyle, string> = {
	[HighlightsButtonStyle.OUTLINED]: 'highlights-admin.button-style-outlined',
	[HighlightsButtonStyle.FILLED]: 'highlights-admin.button-style-filled',
};

const STYLE_OPTIONS = [
	HighlightsButtonStyle.OUTLINED,
	HighlightsButtonStyle.FILLED,
];

export default defineComponent({
	components: {
		BaseEditor,
		FormLabel,
		FormSection,
		FormError,
		SelectBox,
		BasicTextEditor,
		ActionSelector,
	},
	props: BUTTON_EDITOR_PROPS,
	setup(props, ctx) {
		const { doMetaInput } = useHighlightsInput(ctx, computed(() => props.value));
		const $t = useTranslate(ctx);

		// Styles
		const styleOptions = computed(() => STYLE_OPTIONS.map((key) => ({
			key,
			label: $t(STYLE_OPTION_LABELS[key]) as unknown as string,
		})));
		// End styles

		// Colors
		const paletteOptions = computed(() => PALETTE_OPTIONS.map((key) => ({
			key,
			label: $t(PALETTE_OPTION_LABELS[key]) as unknown as string,
		})));
		const selectedPaletteLabel = computed(() => {
			const val = props.value.meta.palette || DEFAULT_PALETTE_KEY;
			return PALETTE_OPTION_LABELS[val];
		});
		const getColorForPalette = (key: HighlightsElementPalette): string | undefined => {
			const palette = props.group.community?.customColorPalette;
			switch (key) {
			case HighlightsElementPalette.PRIMARY:
				return palette?.primary;
			case HighlightsElementPalette.SECONDARY1:
				return palette?.secondary?.[0];
			case HighlightsElementPalette.SECONDARY2:
				return palette?.secondary?.[1];
			case HighlightsElementPalette.SECONDARY3:
				return palette?.secondary?.[2];
			default:
				// eslint-disable-next-line
				const unwanted: never = key;
				throw new Error(`Unable to satisfy colour palette request: ${unwanted}`);
			}
		};
		// END Colors

		// Validation
		const validation = v({
			mainText: {
				value: computed(() => props.value.meta.mainText),
				rules: [required()],
			},
		});
		onMounted(() => {
			validation.validate();
		});

		return {
			validation,
			// Style
			styleOptions,
			STYLE_OPTION_LABELS,
			// Colors
			DEFAULT_PALETTE_KEY,
			paletteOptions,
			selectedPaletteLabel,
			getColorForPalette,
			// Util
			doMetaInput,
			DropdownPosition,
		};
	},
});
